import { render, staticRenderFns } from "./WpItemsListAddNew.vue?vue&type=template&id=5db1cfbe&"
import script from "./WpItemsListAddNew.vue?vue&type=script&lang=js&"
export * from "./WpItemsListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./WpItemsListAddNew.vue?vue&type=style&index=0&id=5db1cfbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports